import React, { useState } from 'react';
import '../styles/CompsTable.css';
import { Bathroom, Bedroom, LotSize, SortArrows, SquareFootage, YearBuilt, Image } from '../assets/icons';
import { clusterColours, colour, formatterLong, numberFormatter, percentageCompact, statusDotColours } from '../styles/GlobalStyles';
import { Badge, Button } from './';
import { getStatusDotColour, propertyStatusBG, propertyStatusText, propertyTypeFormatAbbreviated, sortComps, squareFeetToAcres } from '../functions';
import moment from 'moment';

function CompsTable(props) {
    const data = props.data;
    const setData = props.setData;
    // const subjectProperty = props.subjectProperty;
    const setSorting = props.setSorting;
    const sorting = props.sorting;
    const viewComp = props.viewComp;
    const clickedComp = props.clickedComp;
    const tableRef = props.tableRef;
    const addSelectedComp = props.addSelectedComp;
    const selectedComps = props.selectedComps;
    const rowRefs = props.rowRefs;
    const showScrollableImages = props.showScrollableImages;
    // const viewedComps = props.viewedComps;
    const [hoverComp, setHoverComp] = useState(null);

    const headings = [
        {
            preIcon: null,
            label: "",
            postIcon: null
        },
        {
            preIcon: null,
            label: "",
            postIcon: null
        },
        {
            preIcon: null,
            label: "Address",
            postIcon: <SortArrows fill={sorting.includes("group") ? colour.gray07 : colour.gray05} className="comps-table-sort-icon subtext-margin-left" />,
            sorting: "address"
        },
        {
            preIcon: null,
            label: "Group",
            postIcon: <SortArrows fill={sorting.includes("address") ? colour.gray07 : colour.gray05} className="comps-table-sort-icon subtext-margin-left" />,
            sorting: "group"
        },
        {
            preIcon: null,
            label: "Distance",
            postIcon: <SortArrows fill={sorting.includes("distance") ? colour.gray07 : colour.gray05} className="comps-table-sort-icon subtext-margin-left" />,
            sorting: "distance"
        },
        {
            preIcon: null,
            label: "Comp",
            postIcon: null,//<SortArrows fill={sorting.includes("comp-type") ? colour.gray07 : colour.gray05} className="comps-table-sort-icon subtext-margin-left" />,
            sorting: "comp-type"
        },
        {
            preIcon: null,
            label: "Flip type",
            postIcon: <SortArrows fill={sorting.includes("flip-type") ? colour.gray07 : colour.gray05} className="comps-table-sort-icon subtext-margin-left" />,
            sorting: "flip-type"
        },
        {
            preIcon: null,
            label: "Status",
            postIcon: <SortArrows fill={sorting.includes("status") ? colour.gray07 : colour.gray05} className="comps-table-sort-icon subtext-margin-left" />,
            sorting: "status"
        },
        {
            preIcon: null,
            label: "Price",
            postIcon: <SortArrows fill={sorting.includes("price") ? colour.gray07 : colour.gray05} className="comps-table-sort-icon subtext-margin-left" />,
            sorting: "price"
        },
        {
            preIcon: null,
            label: "Original listing price",
            postIcon: null
        },
        {
            preIcon: null,
            label: "Sale/Listing date",
            postIcon: <SortArrows fill={sorting.includes("date") ? colour.gray07 : colour.gray05} className="comps-table-sort-icon subtext-margin-left" />,
            sorting: "date"
        },
        {
            preIcon: null,
            label: "Days on market",
            postIcon: <SortArrows fill={sorting.includes("days") ? colour.gray07 : colour.gray05} className="comps-table-sort-icon subtext-margin-left" />,
            sorting: "days"
        },
        {
            preIcon: null,
            label: "Property type",
            postIcon: null
        },
        {
            preIcon: <Bedroom fill={sorting.includes("beds") ? colour.gray07 : colour.gray04} size={14} className="subtext-margin-right" />,
            label: "Beds",
            postIcon: <SortArrows fill={sorting.includes("beds") ? colour.gray07 : colour.gray05} className="comps-table-sort-icon subtext-margin-left" />,
            sorting: "beds"
        },
        {
            preIcon: <Bathroom fill={sorting.includes("baths") ? colour.gray07 : colour.gray04} size={14} className="subtext-margin-right" />,
            label: "Baths",
            postIcon: <SortArrows fill={sorting.includes("baths") ? colour.gray07 : colour.gray05} className="comps-table-sort-icon subtext-margin-left" />,
            sorting: "baths"
        },
        {
            preIcon: <YearBuilt fill={sorting.includes("built") ? colour.gray07 : colour.gray04} className="subtext-margin-right" />,
            label: "Built",
            postIcon: <SortArrows fill={sorting.includes("built") ? colour.gray07 : colour.gray05} className="comps-table-sort-icon subtext-margin-left" />,
            sorting: "built"
        },
        {
            preIcon: <SquareFootage fill={sorting.includes("sqft") ? colour.gray07 : colour.gray04} className="subtext-margin-right" />,
            label: "Sqft",
            postIcon: <SortArrows fill={sorting.includes("sqft") ? colour.gray07 : colour.gray05} className="comps-table-sort-icon subtext-margin-left" />,
            sorting: "sqft"
        },
        {
            preIcon: <LotSize fill={sorting.includes("lot") ? colour.gray07 : colour.gray04} className="subtext-margin-right" />,
            label: "Lot size",
            postIcon: <SortArrows fill={sorting.includes("lot") ? colour.gray07 : colour.gray05} className="comps-table-sort-icon subtext-margin-left" />,
            sorting: "lot"
        }
    ];

    const getFlipStatus = (item) => {
        const flipStatus = item.compDetails.flop === true ? "Flop" : item.compDetails.flip === true ? "Flip" : "Non-flip";
        const flipBGColour = flipStatus === "Flop" ? "bg-colour-flop" : flipStatus === "Flip" ? "bg-colour-flip" : "bg-colour-non-flip";
        const flipBGColourDot = flipStatus === "Flop" ? statusDotColours.flop : flipStatus === "Flip" ? statusDotColours.flip : statusDotColours.nonFlip;
        const flippingDescription = item.listingDetails.listingStatus === "for_sale" ? "Property is being flipped, specifically remodeled for re-sale." : "Property was flipped, specifically remodeled for re-sale."
        const flipDescription = flipStatus === "Flop" ? "Property is a flip, but is struggling to sell. On market for over 90 days." : flipStatus === "Flip" ? flippingDescription : "Excellent condition comp, but not remodeled specifically for re-sale.";
        return { flipStatus, flipBGColour, flipDescription, flipBGColourDot };
    };

    const viewLink = (url) => {
        window.open(url, "_blank");
    };

    const getDifferenceInMonths = (val) => {
        const difference = moment().diff(moment(val), 'months');
        if ( difference === 0 ) {
            const differenceDays = moment().diff(moment(val), 'days');
            return `${differenceDays} day${differenceDays === 1 ? "" : "s"} ago`
        }
        else if ( difference === 1 ) {
            return `${difference} month ago`
        }
        else if ( difference >= 24 ) {
            const differenceYears = moment().diff(moment(val), 'years');
            return `${differenceYears} years ago`
        }
        else {
            return `${difference} months ago`
        }
    };

    const changeSorting = async(val) => {
        const checkedVal = val === sorting ? `${val}-desc` : val;
        setSorting(checkedVal);
        const newProps = await sortComps(data, checkedVal);
        setData(newProps);
    };

    const hoverCompFunc = (val) => {
        setHoverComp(val);
    };

    const checkCompSelected = (zpid) => {
        const compIndex = selectedComps.findIndex(e => e.uniqueIds.zillowId === zpid);
        if ( compIndex === -1 ) {
            return false;
        }
        else {
            return true;
        }
    };

    return (
        <div 
            className="comps-table-outer-container"
            ref={tableRef}
        >
            <table 
                className="comps-table-container"
            >
                <thead className="">
                    <tr className="bg-colour-white">
                        {
                            headings.map((item, index) =>
                                <th 
                                    className={"comps-table-label-element " + (item.postIcon !== null ? "cursor-pointer " : "") + (index === 0 ? "comps-table-value-element-left-sticky-number" : index === 1 ? "comps-table-value-element-left-sticky-image" : index === 2 ? "comps-table-value-element-left-sticky-address" : "")}
                                    key={index}
                                    onClick={() => item.postIcon === null ? null : changeSorting(item.sorting)}
                                >
                                    {
                                        item.preIcon !== null &&
                                        item.preIcon
                                    }
                                    <span className={"colour-secondary " + (sorting.includes(item.sorting) ? "body-bold" : "body-regular")}>
                                        {item.label}
                                    </span>
                                    {
                                        item.postIcon !== null &&
                                        item.postIcon
                                    }
                                </th>
                            )
                        }
                    </tr>
                </thead>
                <tbody
                >
                    {
                        data.map((item, index) =>
                            <tr 
                                key={index}
                                className={" " + (clickedComp !== null && clickedComp.uniqueIds.zillowId === item.propertyDetails.uniqueIds.zillowId ? "comps-table-clicked-comp-container" : hoverComp === item.propertyDetails.uniqueIds.zillowId ? "comps-table-value-hover relative-container" : "")}
                                onMouseEnter={() => hoverCompFunc(item.propertyDetails.uniqueIds.zillowId)}
                                onMouseLeave={() => hoverCompFunc(null)}
                                ref={(el) => rowRefs.current[item.propertyDetails.uniqueIds.zillowId] = el}
                            >
                                <td 
                                    className="comps-table-value-element comps-table-value-element-left-sticky-number"
                                    onClick={() => viewComp(item.propertyDetails)}
                                >
                                    <span className="body-regular colour-secondary block-text text-align-center">
                                        {index + 1}
                                    </span>
                                </td>
                                <td 
                                    className="comps-table-value-element comps-table-value-image-container cursor-pointer comps-table-value-element-left-sticky-image"
                                >
                                    {
                                        item.propertyDetails.listingDetails.mlsPhotoUrls === null || item.propertyDetails.listingDetails.mlsPhotoUrls.length === 0 ?
                                        <div className="comps-table-value-no-image">
                                            <Image
                                                className="comps-table-value-no-image-element"
                                                fill={colour.gray05}
                                            />
                                            <span className="label-regular colour-secondary block-text text-align-center">
                                                No image
                                            </span>
                                        </div>
                                        :
                                        <img
                                            src={item.propertyDetails.listingDetails.mlsPhotoUrls[0]}
                                            className="comps-table-value-featured-image"
                                            alt={item.propertyDetails.addressDetails.streetAddress}
                                            onClick={() => showScrollableImages(item.propertyDetails)}
                                        />
                                    }
                                </td>
                                <td 
                                    className="comps-table-value-element comps-table-value-element-left-sticky-address"
                                >
                                    <span 
                                        className="body-regular colour-primary block-text margin-x-x-small"
                                        onClick={() => viewComp(item.propertyDetails)}
                                    >
                                        {item.propertyDetails.addressDetails.streetAddress}
                                    </span>
                                    <div className="comps-table-addres-links-container">
                                        <span 
                                            className="label-regular underline colour-secondary cursor-pointer"
                                            onClick={() => viewLink(item.propertyDetails.propertyUrls.zillowUrl)}
                                        >
                                            Zillow
                                        </span>
                                        <span className="label-regular colour-secondary margin-sides-small">
                                            •
                                        </span>
                                        <span 
                                            className="label-regular underline colour-secondary cursor-pointer"
                                            onClick={() => viewLink(item.propertyDetails.propertyUrls.realtorUrl)}
                                        >
                                            Realtor
                                        </span>
                                    </div>
                                </td>
                                <td 
                                    className="comps-table-value-element"
                                    onClick={() => viewComp(item.propertyDetails)}
                                >
                                    <div 
                                        className="cluster-legend-chip cursor-pointer"
                                        style={{ backgroundColor: clusterColours[item.propertyDetails.compClusterScore.group].bg }}
                                    >
                                        <span className="body-regular colour-primary">
                                            Group {String.fromCharCode(65 + item.propertyDetails.compClusterScore.group)}
                                        </span>
                                    </div>
                                </td>
                                <td 
                                    className="comps-table-value-element"
                                    onClick={() => viewComp(item.propertyDetails)}
                                >
                                    <span className="body-regular colour-primary">
                                        {
                                            item.propertyDetails.compDetails.distanceMiles === null ?
                                            "N/A"
                                            :
                                            `${item.propertyDetails.compDetails.distanceMiles.toFixed(2)} mi`
                                        }
                                    </span>
                                </td>
                                <td 
                                    className="comps-table-value-element"
                                    onClick={() => viewComp(item.propertyDetails)}
                                >
                                    <span className="body-regular colour-primary">
                                        {
                                            item.propertyDetails.compDetails.arv === true ?
                                            "ARV"
                                            :
                                            "As-is"
                                        }
                                    </span>
                                </td>
                                <td 
                                    className="comps-table-value-element comps-table-value-flip-badge relative-container"
                                    onClick={() => viewComp(item.propertyDetails)}
                                >
                                    <div className="comps-table-value-badge-container">
                                        {
                                            item.propertyDetails.compDetails.arv === true &&
                                            <Badge
                                                bgColour={getFlipStatus(item.propertyDetails).flipBGColour}
                                                text={getFlipStatus(item.propertyDetails).flipStatus}
                                                statusDot={true}
                                                statusDotColour={getFlipStatus(item.propertyDetails).flipBGColourDot}
                                                textClass="body-semibold colour-primary"
                                                icon={null}
                                                tooltip={true}
                                                tooltipBody={getFlipStatus(item.propertyDetails).flipDescription}
                                                tooltipPosition={"top"}
                                                iconLeft={false}
                                            />
                                        }
                                    </div>
                                </td>
                                <td 
                                    className="comps-table-value-element"
                                    onClick={() => viewComp(item.propertyDetails)}
                                >
                                    <div className="comps-table-value-badge-container">
                                        <Badge
                                            bgColour={propertyStatusBG(item.propertyDetails, false)}
                                            text={propertyStatusText(item.propertyDetails)}
                                            statusDot={true}
                                            statusDotColour={getStatusDotColour(item.propertyDetails)}
                                            textClass="body-semibold colour-primary"
                                            icon={null}
                                            tooltip={false}
                                            tooltipBody={null}
                                            tooltipPosition={null}
                                            iconLeft={false}
                                        />
                                    </div>
                                </td>
                                <td 
                                    className="comps-table-value-element"
                                    onClick={() => viewComp(item.propertyDetails)}
                                >
                                    <span className="body-regular colour-secondary">
                                        {
                                            item.propertyDetails.listingDetails.listingStatus === "sold" || item.propertyDetails.listingDetails.listingStatus === "for_rent" ?
                                            "Sold for"
                                            :
                                            "Current price"
                                        }
                                    </span>
                                    {
                                        item.propertyDetails.listingDetails.listingStatus === "sold" || item.propertyDetails.listingDetails.listingStatus === "for_rent" ?
                                        <div className="">
                                            <span className="body-bold colour-primary">
                                                {formatterLong.format(item.propertyDetails.listingDetails.soldListingPrice).replace(".00", "")}
                                            </span>
                                            <span className="body-bold colour-primary">
                                                •
                                            </span>
                                            <span className="body-bold colour-primary">
                                                {formatterLong.format(Math.round(item.propertyDetails.listingDetails.soldListingPrice / item.propertyDetails.propertyAttributes.livingSquareFootage)).replace(".00", "")}/sqft
                                            </span>
                                        </div>
                                        :
                                        <div className="">
                                            <span className="body-bold colour-primary">
                                                {formatterLong.format(item.propertyDetails.listingDetails.listingPrice).replace(".00", "")}
                                            </span>
                                            <span className="body-bold colour-primary">
                                                •
                                            </span>
                                            <span className="body-bold colour-primary">
                                                {formatterLong.format(Math.round(item.propertyDetails.listingDetails.listingPrice / item.propertyDetails.propertyAttributes.livingSquareFootage)).replace(".00", "")}/sqft
                                            </span>
                                        </div>
                                    }
                                    {
                                        (item.propertyDetails.listingDetails.listingStatus === "sold" || item.propertyDetails.listingDetails.listingStatus === "for_rent") && item.propertyDetails.listingDetails.saleSoldPriceDifference > 0 ?
                                        <span className="body-regular colour-error text-italic block-text">
                                            -{percentageCompact.format(item.propertyDetails.listingDetails.saleSoldPriceDifference / item.propertyDetails.listingDetails.saleListingPrice)} below initial list price
                                        </span>
                                        :
                                        (item.propertyDetails.listingDetails.listingStatus === "sold" || item.propertyDetails.listingDetails.listingStatus === "for_rent") && item.propertyDetails.listingDetails.saleSoldPriceDifference < 0 ?
                                        <span className="body-regular colour-green text-italic block-text">
                                            +{percentageCompact.format((item.propertyDetails.listingDetails.saleSoldPriceDifference * -1) / item.propertyDetails.listingDetails.saleListingPrice)} above initial list price
                                        </span>
                                        :
                                        item.propertyDetails.listingDetails.listSalePriceDifference > 0 ?
                                        <span className="body-regular colour-error text-italic block-text">
                                            -{percentageCompact.format(item.propertyDetails.listingDetails.listSalePriceDifference / item.propertyDetails.listingDetails.saleListingPrice)} below initial list price
                                        </span>
                                        :
                                        item.propertyDetails.listingDetails.listSalePriceDifference < 0 &&
                                        <span className="body-regular colour-green text-italic block-text">
                                            +{percentageCompact.format((item.propertyDetails.listingDetails.listSalePriceDifference * -1) / item.propertyDetails.listingDetails.saleListingPrice)} above initial list price
                                        </span>
                                    }
                                </td>
                                <td 
                                    className="comps-table-value-element"
                                    onClick={() => viewComp(item.propertyDetails)}
                                >
                                    <span className="body-regular colour-secondary">
                                        Listed for
                                    </span>
                                    <div className="">
                                        <span className="body-regular colour-primary">
                                            {formatterLong.format(item.propertyDetails.listingDetails.saleListingPrice).replace(".00", "")}
                                        </span>
                                        <span className="body-regular colour-primary">
                                            •
                                        </span>
                                        <span className="body-regular colour-primary">
                                            {formatterLong.format(Math.round(item.propertyDetails.listingDetails.saleListingPrice / item.propertyDetails.propertyAttributes.livingSquareFootage)).replace(".00", "")}/sqft
                                        </span>
                                    </div>
                                </td>
                                <td 
                                    className="comps-table-value-element"
                                    onClick={() => viewComp(item.propertyDetails)}
                                >
                                    <span className="body-regular colour-primary">
                                        {
                                            item.propertyDetails.listingDetails.listingStatus === "sold" || item.propertyDetails.listingDetails.listingStatus === "for_rent" ?
                                            getDifferenceInMonths(item.propertyDetails.listingDetails.soldListingDate)
                                            :
                                            getDifferenceInMonths(item.propertyDetails.listingDetails.saleListingDate)
                                        }
                                    </span>
                                </td>
                                <td 
                                    className="comps-table-value-element relative-container"
                                    onClick={() => viewComp(item.propertyDetails)}
                                >
                                    <span className="body-regular colour-primary">
                                        {
                                            item.propertyDetails.listingDetails.listingStatus === "sold" || item.propertyDetails.listingDetails.listingStatus === "for_rent" ?
                                            <span className="body-regular colour-primary">
                                                {item.propertyDetails.listingDetails.daysUntilSold} days
                                            </span>
                                            :
                                            <span className="body-regular colour-primary">
                                                {moment().diff(moment(item.propertyDetails.listingDetails.saleListingDate), 'days')} days
                                            </span>
                                        }
                                    </span>
                                </td>
                                <td 
                                    className="comps-table-value-element"
                                    onClick={() => viewComp(item.propertyDetails)}
                                >
                                    <span className="body-regular colour-primary">
                                        {propertyTypeFormatAbbreviated(item.propertyDetails.propertyAttributes.propertyType)}
                                    </span>
                                </td>
                                <td 
                                    className="comps-table-value-element"
                                    onClick={() => viewComp(item.propertyDetails)}
                                >
                                    <span className="body-regular colour-primary">
                                        {item.propertyDetails.propertyAttributes.bedrooms} bd
                                    </span>
                                </td>
                                <td 
                                    className="comps-table-value-element"
                                    onClick={() => viewComp(item.propertyDetails)}
                                >
                                    <span className="body-regular colour-primary">
                                        {item.propertyDetails.propertyAttributes.bathrooms} ba
                                    </span>
                                </td>
                                <td 
                                    className="comps-table-value-element"
                                    onClick={() => viewComp(item.propertyDetails)}
                                >
                                    <span className="body-regular colour-primary">
                                        {item.propertyDetails.propertyAttributes.yearBuilt}
                                    </span>
                                </td>
                                <td 
                                    className="comps-table-value-element"
                                    onClick={() => viewComp(item.propertyDetails)}
                                >
                                    <span className="body-regular colour-primary">
                                        {numberFormatter.format(item.propertyDetails.propertyAttributes.livingSquareFootage)} sqft
                                    </span>
                                </td>
                                <td 
                                    className="comps-table-value-element"
                                    onClick={() => viewComp(item.propertyDetails)}
                                >
                                    <span className="body-regular colour-primary">
                                        {
                                            item.propertyDetails.propertyAttributes.lotSquareFootage === null || item.propertyDetails.propertyAttributes.lotSquareFootage === 0 ?
                                            "N/A"
                                            :
                                            squareFeetToAcres(item.propertyDetails.propertyAttributes.lotSquareFootage)
                                        }
                                    </span>
                                </td>
                                <td className="comps-table-button-container">
                                    <Button
                                        buttonType={checkCompSelected(item.propertyDetails.uniqueIds.zillowId) === false ? "primary-button" : "light-button"}
                                        size="medium"
                                        text={checkCompSelected(item.propertyDetails.uniqueIds.zillowId) === false ? "Save" : "Remove"}
                                        cta={() => addSelectedComp(item.propertyDetails.uniqueIds.zillowId)}
                                        disabled={false}
                                        leftIcon={null}
                                        leftIconClass=""
                                        rightIcon={null}
                                        rightIconClass=""
                                        alt=""
                                        standardIcon={false}
                                        badge={false}
                                        badgeVal={null}
                                        badgeBG={null}
                                        buttonRef={null}
                                        spinner={false}
                                    />
                                </td>
                            </tr>
                        )
                    }
                </tbody>
            </table>
        </div>
    )
};

export default CompsTable;